import { forwardRef, useState, useCallback } from 'react'

import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import CloseButton from 'components/CloseButton'
import Dialog from '@mui/material/Dialog'
import Grow, { GrowProps } from '@mui/material/Grow'
import IconButton from '@mui/material/IconButton'

import Info from '@mui/icons-material/InfoOutlined'

const Transition = forwardRef<unknown, GrowProps>(function Transition(props, ref) {
  return <Grow ref={ref} {...props} />
})

const HelpDialog = styled(Dialog)({
  backgroundColor: 'transparent',

  '& .MuiDialog-paper': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    maxWidth: 360,
  },
})

const HelpImage = styled('img')({
  width: '100%',
})

interface HelpProps {
  image: string
}

export default function Help({ image }: HelpProps) {
  const [open, setOpen] = useState(false)
  const toggleInfo = useCallback(() => setOpen((isOpen) => !isOpen), [])

  return (
    <>
      <IconButton color="inherit" onClick={toggleInfo}>
        <Info color="inherit" fontSize="large" />
      </IconButton>
      <HelpDialog
        fullWidth
        maxWidth="sm"
        open={open}
        onClose={toggleInfo}
        TransitionComponent={Transition}
      >
        <Box p={2} width="100%" textAlign="center">
          <HelpImage src={image} alt="info" />
        </Box>
        <Box textAlign="right" position="absolute" width="100%">
          <CloseButton onClick={toggleInfo} />
        </Box>
      </HelpDialog>
    </>
  )
}
